var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{class:[
    'socials',
    { 'socials--red': _vm.type === 'red' },
    { 'socials--blue': _vm.type === 'blue' },
  ]},[_c('hot-container',{staticClass:"socials__container"},[_c('hot-title',{staticClass:"weight-800",attrs:{"tag":"h2","data-testid":"title"}},[_vm._v("\n      "+_vm._s(_vm.title)+"\n    ")]),_vm._v(" "),_c('p',{staticClass:"socials__description",attrs:{"data-testid":"description"},domProps:{"innerHTML":_vm._s(_vm.description)}}),_vm._v(" "),_c('hot-button-list',{attrs:{"buttons":_vm.buttons,"class-button-list":[
        'socials__button-list',
        { 'socials__button-list--red': _vm.type === 'red' },
        { 'socials__button-list--blue': _vm.type === 'blue' },
      ],"type":_vm.type,"data-testid":"button-list"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }